const inverted = (theme) => ({
    color: theme.colors.white,
    background: "transparent",
    border: `rgba(${theme.colors.transparentWhite},0)`,
    focus: {
        border: theme.colors.primaryLight,
    },
    hover: {
        border: `rgba(${theme.colors.transparentWhite},0.9)`,
    },
    active: {
        color: `rgba(${theme.colors.transparentWhite},0.8)`,
    },
    disabled: {
        color: `rgba(${theme.colors.transparentWhite},0.4)`,
    },
});
export const linkStyles = (theme) => ({
    primary: {
        color: theme.colors.primaryLight,
        background: "transparent",
        border: `rgba(${theme.colors.transparentWhite},0)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            border: theme.colors.primary,
            color: theme.colors.primary,
        },
        active: {
            color: theme.colors.primaryDark,
        },
        disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.26)`,
        },
    },
    secondary: {
        color: theme.colors.black,
        background: "transparent",
        border: `rgba(${theme.colors.transparentWhite},0)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            color: theme.colors.grey15,
            border: theme.colors.grey15,
        },
        active: {
            color: theme.colors.grey13,
        },
        disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.26)`,
        },
    },
    light: {
        color: theme.colors.grey14,
        background: "transparent",
        border: `rgba(${theme.colors.transparentWhite},0)`,
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            border: theme.colors.black,
        },
        active: {
            color: theme.colors.white,
        },
        disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.26)`,
        },
    },
    inverted: inverted(theme),
    invertedOnColor: Object.assign(Object.assign({}, inverted(theme)), { focus: { border: theme.colors.primaryDark } }),
    flat: {
        color: theme.colors.black,
        border: `rgba(${theme.colors.transparentBlack},0)`,
        background: "transparent",
        focus: {
            border: theme.colors.primaryLight,
        },
        hover: {
            background: `rgba(${theme.colors.transparentBlack},0.08)`,
        },
        active: {
            background: theme.colors.grey15,
            border: theme.colors.grey15,
            color: theme.colors.white,
        },
        disabled: {
            color: `rgba(${theme.colors.transparentBlack},0.26)`,
        },
    },
});
